module.exports = __webpack_public_path__ + "static/img/5.89b9c48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/5.png
// module id = fPld
// module chunks = 0